import { Flex } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Input, Modal, Toggle } from '@feathr/components';
import { cssVar } from '@feathr/hooks';

import * as styles from './GeoFilterModal.css';

type TModalContext = 'create' | 'edit';

interface IGeoFilterModalProps {
  opened: boolean;
  onClose: () => void;
  context?: TModalContext;
}

function GeoFilterModal({
  opened: isModalOpen,
  onClose: closeModal,
  context = 'create',
}: Readonly<IGeoFilterModalProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      bodyClassName={styles.body}
      description={t('{{count}} locations remaining.', { count: 50 })}
      leftActions={[
        <Button key={'add-location'} onClick={closeModal}>
          {t('Add location')}
        </Button>,
      ]}
      onClose={closeModal}
      opened={isModalOpen}
      rightActions={[
        <Button key={'cancel'} onClick={closeModal}>
          {t('Cancel')}
        </Button>,
        <Button key={'save'} onClick={closeModal}>
          {t('{{context}}', {
            context: context === 'create' ? t('Save') : t('Apply'),
          })}
        </Button>,
      ]}
      size={'xl'}
      title={t('{{context}} GeoFilter Set', {
        context: context === 'create' ? t('Create') : t('Edit'),
      })}
    >
      <Flex direction={'column'} gap={cssVar('--spacing-2')} w={'100%'}>
        <Input label={t('Geofilter set name')} placeholder={t('Geofilter set name')} />
        <Toggle
          color={'slate'}
          defaultChecked={false}
          label={t('Assign as default set')}
          layout={'well'}
        />
      </Flex>
    </Modal>
  );
}

export default GeoFilterModal;
